import { z } from 'zod'

import ZBaseAction from './base'

const ZEndCampaignAction = ZBaseAction.extend({
  finishFlow: z.object({}),
})

export default ZEndCampaignAction
